import { callAuditService } from '../api/api'

const win: any = window
const serverURL = win['base_portal_url'];
const errorPage = win['errorPageURL'];
const timeoutPage = win['timeoutPageURL']

export const handleApiError = (error: any, step: any) => {
    const stepName = `PDP_${step}`
    const genericErrorPage = `${serverURL}${errorPage}`
    const timeoutErrorPage = `${serverURL}${timeoutPage}`

    callAuditService(error, stepName).finally(() => {
        const redirectURL = error?.response?.status === 504 ? timeoutErrorPage : genericErrorPage;
        window.location.href = redirectURL;
    });
}